module.exports = {
	config: {
		roleOptionScope: 'mblx',
	},

	model: {
		entityTable: false
	},

	events: {
		action: {
			type: 'click',
			selector: 'section.top button',
			action: function(event){
				event.preventDefault()
				event.stopImmediatePropagation()

				const self = event.data.component
				const $target = $(event.target)
				if($target.length > 0){
					const fieldType = $target.data('fieldType')
					if(self.model.entityTable){
						if(fieldType === 'refresh'){
							self.model.entityTable.refreshData()
						} else if(fieldType === 'chooseAll'){
							self.chooseAll()
						}
					}
				}
			}
		}
	},

	methods: {
		async chooseAll(){
			await this.model.entityTable.chooseAll()
		},

		async choosePrompt(productNumber, productAttributes){
			if(!productNumber){
				console.error('MISSING PRODUCT_NUMBER')
				return
			}

			let result
			const {
				decision = {
					decision: 'outstanding',
					promptID: null,
				},
				decisionComponent,
			} = result = await this.performDecision(
				'showMblxProductPromptAssociationsPromptChooser',
				{
					productNumber,
					productAttributes,
				}
			)

			if(decisionComponent){
				let modal
				decisionComponent.closest('base_modal_modal', m => modal = m)
				if(modal){
					await modal.hide()
				}
			}

			return decision
		}
	},

	hooks: {
		attach: function($element, options){
			if(!this.model.entityTable){
				this.find('base_tableSimple_table', t => this.model.entityTable = t)
			}
		},

		filtersChanged: function($element, options){
			this.triggerFind('filtersChanged', options);
		},

		colTagsBubbleSelected: function($element, options){
			this.triggerFind('colTagsBubbleSelected', options);
		},
	}
};
